<template lang="pug">
  div(v-if="urgentCan" class="trash-can-wrapper block--inner")
    div
      div(class="trash-can__number")
        span {{'no.'+urgentCan.canId}}
      div(class="trash-can__type")
        div(class="decoration")
        span {{type}}
      div(class="trash-can__percentage")
        span {{percentage}}%
      div(class="trash-can__chart")
        fullness-line-chart(:fullness="percentage" :index="index")
    div
      div(class="trash-can__owner")
        span {{urgentCan.owner.name}}
      div(class="trash-can__address")
        span {{urgentCan.location.section}}
    div(class="trash-can__btn")
      div(class="btn btn__email")
        img(:src="`${require('@/assets/icon/list_mail_normal.svg')}`")
      div(class="btn btn__location")
        img(:src="`${require('@/assets/icon/list_location_normal.svg')}`")
      div(class="btn btn__more")
        img(:src="`${require('@/assets/icon/list_arrow.svg')}`")
</template>

<script>
import FullnessLineChart from '@/components/chart/FullnessLineChart.vue'

export default {
  name: 'TrashCanWrapper',
  components: {
    FullnessLineChart
  },
  props: {
    urgentCan: {
      type: Object,
      default: null
    },
    index: Number
  },
  computed: {
    type () {
      return this.urgentCan.recycling.fullness >= 70 ? '回收'
        : this.urgentCan.trash.fullness >= 70 ? '垃圾' : '回收+垃圾'
    },
    percentage () {
      return this.urgentCan.recycling.fullness >= 70 ? this.urgentCan.recycling.fullness
        : this.urgentCan.trash.fullness >= 70 ? this.urgentCan.trash.fullness : '回收+垃圾'
    }
  },

  data () {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.trash-can-wrapper {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 2.5fr 1fr 0.5fr;
  column-gap: 20px;
  > div:nth-child(1) {
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  > div:nth-child(2) {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(2, 1fr);
  }
  > div:nth-child(3) {
    display: flex;
    align-items: center;
    > div:nth-child(1) {
      margin-right: 20px;
    }
    > div:nth-child(2) {
      margin-right: 25px;
    }
  }
  .trash-can {
    &__number {
      font-size: 12px;
      background-color: map-get($colors, dark-red);
      color: white;
      padding: 6px 12px;
      border-radius: 15px;
    }
    &__type {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
    &__percentage {
      font-size: 20px;
      color: map-get($colors, dark-red);
    }
    &__chart {
      width: 150px;
      height: 100%;
    }
    &__owner {
      font-size: 16px;
    }
    &__address {
      font-size: 16px;
    }
  }
  .decoration {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: map-get($colors, dark-red);
    margin-right: 8px;
  }
}
</style>
